export default __webpack_public_path__ + "../staticImages/jubilaeum-260.png";